import * as React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { HomePage } from "../../components/home/HomePage";
import { AppContext } from "../../setup/context";

export const ApplicationDefaultHome = () => {
    const context = React.useContext(AppContext);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [showHomePage, setShowHomePage] = React.useState<boolean>(false);

    // Check if user explicitly clicked on home breadcrumb
    const isExplicitHomeNavigation = searchParams.get("home") === "true";

    React.useEffect(() => {
        const redirect = async () => {
            const identity = await context.getIdentity();
            const preference = context.getPreference();

            // When user explicitly clicks home breadcrumb from any page, show new home page
            if (isExplicitHomeNavigation) {
                setShowHomePage(true);
                return;
            }

            // When user has a preference, redirect to it
            if (!!preference && preference.userId === identity.id && !!preference.instanceId) {
                navigate(`/instance/${preference.instanceId}/home`);
            } else {
                // No preference - show home page
                setShowHomePage(true);
            }
        };
        redirect();
    }, [isExplicitHomeNavigation]);

    const handleInstanceSelect = (instanceId: string) => {
        navigate(`/instance/${instanceId}/home`);
    };

    return (
        <div>
            {showHomePage && <HomePage onInstanceSelect={handleInstanceSelect} />}
        </div>
    );
};